import { KeyboardAvoidingView, Platform, Pressable, useWindowDimensions, View, ScrollView, Image, TouchableOpacity } from 'react-native'
import React, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react'
import { ThemeConsumer } from '@rneui/themed'
import { ZenBadge, ZenButton, ZenCheckBox, ZenDropdown, ZenIcon, ZenInput, ZenSwitch, ZenText, ZenToast, ZenToolTip } from 'zen-core-elements'
import { formikLocation, ftImageValue, ProductFormValues, variantValue } from '../productModule'
import { useAppDispatch } from '../../../../redux/hooks'
import { config } from '../../../../shared/environment'
import { checkDuplicatesRedux } from '../../../../redux/slices/commonSlice'
import { DropdownRenderItemInterface, ItemTypeValue } from 'zen-core-elements/src/elements/zenDropdown/dropdownPicker'
import { FormikProps } from 'formik'
import Popover from 'react-native-popover-view'
import CommonDialogBox from '../../../../shared/commonComponents/commonDialogBox'
import { useAppNavigation } from '../../../../types/@react-navigation/navigation'
import { appColors } from 'zen-core-elements/src/shared/constants'
import CommonImageUpload, { commonPickerRes } from '../../../../shared/commonComponents/commonImageUpload'
import { ZenRBSheetRef } from 'zen-core-elements/src/elements/zenRBSheet/RBSheet'
import ProductBarcodeGenerator from './productBarcodeGenerator'

interface DummyGeneralProps {
  formik: FormikProps<ProductFormValues>
  singleVid: number | undefined,
  isProductWrite: boolean
  setDupLoader: Dispatch<SetStateAction<{ productName: boolean, sku: boolean }>>
  productId: number | undefined
  isDuplicateSku: boolean,
  setIsDuplicateSku: Dispatch<SetStateAction<boolean>>
  isDuplicateValue: boolean,
  setIsDuplicateValue: Dispatch<SetStateAction<boolean>>
  dimensionOptions: ItemTypeValue[]
  categoryOptions: ItemTypeValue[]
  multiTextArray: string[]
  weightOptions: ItemTypeValue[]
  brandOptions: ItemTypeValue[]
  // venderDropdownData: ItemTypeValue[]
  imgUploading: boolean,
  setImgUploading: Dispatch<SetStateAction<boolean>>
  taxCopy: number[],
  setTaxCopy: Dispatch<SetStateAction<number[]>>
  defaultTax: number[],
  taxClassOptions: { label: string, value: number, isEnabledAllProducts: boolean, isEnabled: boolean }[],
  multiTax: string[] | undefined,
  setMultiTax: Dispatch<SetStateAction<string[] | undefined>>
  setChecked: Dispatch<SetStateAction<{ [Key: string]: { id?: string, checked?: boolean } }[]>>
  rvarIds: number[],
  setRvarIds: Dispatch<SetStateAction<number[]>>
  setSelectedVarObj: Dispatch<SetStateAction<{ label?: string, value: number }[]>>
  locationOptions: { label?: string, value: number }[],
  multiCategory: string[],
  setMultiCategory: Dispatch<SetStateAction<string[]>>
  multipleImages: { imgKey: string, id: number }[],
  setDelMain: Dispatch<SetStateAction<{ image?: string; fileName?: string; isDelete: boolean; }[]>>
  setMainImage: Dispatch<SetStateAction<ProductFormValues["featuredImage"][] | null>>
}

const ProductGeneral = ({ formik, singleVid, isProductWrite, setDupLoader, productId, isDuplicateSku, setIsDuplicateSku, isDuplicateValue, setIsDuplicateValue, dimensionOptions, categoryOptions, multiTextArray, weightOptions, brandOptions, imgUploading, setImgUploading, setTaxCopy, taxCopy, defaultTax, taxClassOptions, multiTax, setMultiTax, setChecked, rvarIds, setRvarIds, setSelectedVarObj, locationOptions, multiCategory, setMultiCategory, multipleImages, setDelMain, setMainImage }: DummyGeneralProps) => {
  const scrollRef = useRef<ScrollView>(null)
  const dispatch = useAppDispatch()
  const navigation = useAppNavigation()
  const { height, width } = useWindowDimensions()
  // Variable which is used to store the url of single image
  const [ftImage, setFtImage] = useState<ftImageValue[]>([])
  // Variable which is used to store the picked additional images
  const [multiImages, setMultiImages] = useState<any[]>([])
  // Variable used to store the product name for duplicate check
  const [dupName, setDupName] = useState('')
  //Variable which is used to set SKU value
  const [Sku, setSku] = useState('')
  // Variable which is used to store category dropdown open status
  const [categoryOpen, setCategoryOpen] = useState(false)
  // Variable which is used to store weight dropdown open status
  const [weightOpen, setWeightOpen] = useState(false)
  //Variable used to handle enable variant dialog
  const [isEnabVar, setIsEnabVar] = useState(false)
  // Variable which is used to store brand open status 
  const [brandOpen, setBrandOpen] = useState(false)
  // Variable which is used to store tax open status
  const [taxOpen, setTaxOpen] = useState(false)
  //State variable to store boolean value for dimension dropdown open
  const [isDimensionOpen, setIsDimensionOpen] = useState<boolean>(false);
  // Variable which is used to store the type of the gallery upload
  const [zenType, setZenType] = useState("")
  let OpenLocation: boolean[] = []
  //Variable used to handle clear variant dialog
  const [isClearVar, setIsClearVar] = useState(false)
  //Needs to change 
  formik?.values?.locArr.map(() => { OpenLocation.push(false) })
  // Variable which is used to handle dropdown open operation for location
  const [locationOpen, setLocationOpen] = useState<boolean[]>(OpenLocation)
  //State variable to store boolean value for popover
  const [isPopover, setIsPopover] = useState<boolean>(false);
  const bottomRef = useRef<ZenRBSheetRef>(null)

  const selectedTaxText = useMemo(() => {
    if (multiTax && multiTax.length > 0) {
      return multiTax.length > 3
        ? `${multiTax.slice(0, 3).join(', ')}...`
        : multiTax.join(', ');
    }
    const selectedIds = formik?.values?.taxClasses;
    if (!selectedIds || !selectedIds.length || !taxClassOptions?.length) {
      return '';
    }
    const selectedLabels = taxClassOptions
      .filter((item) => selectedIds.includes(item?.value as number))
      .map((item) => item?.label)
      .filter(Boolean);

    if (!selectedLabels.length) return '';
    if (selectedLabels.length > 3) {
      return `${selectedLabels.slice(0, 3).join(', ')}...`;
    }
    return selectedLabels.join(', ');
  }, [multiTax, formik?.values?.taxClasses, taxClassOptions]);

  const selectedCategoryText = useMemo(() => {
    if (multiCategory && multiCategory.length > 0) {
      return multiCategory.length > 3
        ? `${multiCategory.slice(0, 3).join(', ')}...`
        : multiCategory.join(', ');
    }
    const selectedIds = formik?.values?.categories;
    if (!selectedIds || !selectedIds.length || !categoryOptions?.length) {
      return '';
    }
    const selectedLabels = categoryOptions
      .filter((item) => selectedIds.includes(item?.value as number))
      .map((item) => item?.label)
      .filter(Boolean);

    if (!selectedLabels.length) return '';
    if (selectedLabels.length > 3) {
      return `${selectedLabels.slice(0, 3).join(', ')}...`;
    }
    return selectedLabels.join(', ');
  }, [multiCategory, formik?.values?.categories, categoryOptions]);

  // First selected category / the chosen brand, by name - the auto SKU tokens
  // are built from names, not ids.
  const skuCategoryName = useMemo(() => {
    const firstId = formik?.values?.categories?.[0];
    if (firstId === undefined || firstId === null) return '';
    return categoryOptions?.find((item) => item?.value === firstId)?.label ?? '';
  }, [formik?.values?.categories, categoryOptions]);

  // initialValues holds what came back from the API, so this stays false while
  // the user is typing a SKU into a new product.
  const hasSavedSku = Boolean(formik?.initialValues?.Sku?.trim());

  const skuBrandName = useMemo(() => {
    const brandId = formik?.values?.brand;
    if (brandId === undefined || brandId === null) return '';
    return brandOptions?.find((item) => item?.value === brandId)?.label ?? '';
  }, [formik?.values?.brand, brandOptions]);
  // Variable used to handle clear variant props
  const clearVarProps = {
    content: 'Are you sure you want to disable the variant(s), since it will also be removed from this product associated with it?',
    button: [
      { id: 2, name: 'Yes', },
      { id: 1, name: 'No', },
    ],
    image: {
      iconName: 'delete-outline',
      color: appColors.inActiveColor
    }
  }

  //Variable used to handle enable variant toggle props
  const enabVarProps = {
    content: 'Are you sure you want to enable variants?',
    button: [
      { id: 2, name: 'Yes' },
      { id: 1, name: 'No', },
    ],
    image: {
      iconName: 'information-outline',
      color: appColors.pendingColor
    }
  }

  const confirmation = (value: { id: number, name: string }) => {
    if (isClearVar && value?.name === 'Yes') {
      if (formik?.values?.ProductName.length > 0) {
        if (productId) {
          let tempIds: number[] = (rvarIds[0] == singleVid) ? [] : [...rvarIds]
          Object.keys(formik.values?.varCombinations).map((key) => {
            if (formik.values?.varCombinations?.[key]?.vid) {
              tempIds.push(formik.values?.varCombinations?.[key]?.vid)
            }
          })
          setRvarIds(tempIds)
        }
        addSingleVariant(formik?.values?.ProductName, "new")
      }
      else {
        formik.setFieldValue("varCombinations", {});

      }
      formik.setFieldValue("selectedVariants", [])
      setSelectedVarObj([])
      setChecked([])
      formik?.setFieldValue('isMultiVariants', !formik?.values?.isMultiVariants)
      formik?.setFieldValue('Sku', '')
      formik.setFieldValue('Upc', '')
      formik.setFieldValue('square', '')
      formik.setFieldValue('sellingPrice', '')
      formik.setFieldValue('WholesalePrice', '')
      formik.setFieldValue('MRP', '')
      setIsClearVar(false)
    }
    else if (isClearVar && value?.name === 'No') {
      setIsClearVar(false)
    }
    else if (isEnabVar && value?.name === 'Yes') {
      setRvarIds(formik.values?.varCombinations?.[formik?.values.ProductName]?.vid ? [formik.values?.varCombinations?.[formik?.values.ProductName]?.vid as number] : [...rvarIds])
      formik.setFieldValue("varCombinations", {});
      formik?.setFieldValue('isMultiVariants', !formik?.values.isMultiVariants)
      setIsEnabVar(false)
    }
    else if (isEnabVar && value?.name === 'No') {
      setIsEnabVar(false)
    }
  }

  //Debounce for product name
  useEffect(() => {
    const duplicateDebounceFunction = setTimeout(() => {
      if (dupName != '') {
        setDupLoader(prev => ({ ...prev, productName: true }))
        const data = {
          "value": dupName,
          "tableName": "products",
          "columnName": "name",
          "id": productId ? productId : 0,
          "storeId": true
        }
        dispatch(checkDuplicatesRedux({ data, storeId: config.storeId })).unwrap().then((res) => {
          if (res) {
            setDupLoader(prev => ({ ...prev, productName: false }))
            res?.result?.alreadyExists ? setIsDuplicateValue(true) : setIsDuplicateValue(false)
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }, 1000);
    return () => clearTimeout(duplicateDebounceFunction);
  }, [dupName]);

  //Debounce for SKU
  useEffect(() => {
    if (Sku != '') {
      const duplicateSkuDebounceFunction = setTimeout(() => {
        setDupLoader(prev => ({ ...prev, sku: true }))
        checkIsDuplicateSKU(Sku, formik.values?.varCombinations?.[formik?.values?.ProductName]?.vid ? formik.values?.varCombinations?.[formik?.values?.ProductName]?.vid as number : null)
      }, 1000);
      return () => clearTimeout(duplicateSkuDebounceFunction);
    }
  }, [Sku]);

  const hasInitializedImages = useRef(false);

  useEffect(() => {
    if (multipleImages && multipleImages.length > 0 && !hasInitializedImages.current) {
      setMultiImages(multipleImages)
      hasInitializedImages.current = true;
    }
  }, [multipleImages])


  //Function to check duplicate SKU
  const checkIsDuplicateSKU = (text: string, vid: number | null) => {
    const data = {
      "value": text,
      "tableName": "variantCombinationDetails",
      "columnName": "sku",
      "id": vid ? vid : 0,
      "storeId": true,
    }
    dispatch(checkDuplicatesRedux({ data, storeId: config.storeId })).unwrap().then((res) => {
      setDupLoader(prev => ({ ...prev, sku: false }))
      res?.result?.alreadyExists ? setIsDuplicateSku(true) : setIsDuplicateSku(false)
    }).catch((err) => {
      console.log(err)
    })
  }

  //Function used to add varCombination for singleVariant
  const addSingleVariant = (name: string, type: string) => {
    const updatedCombinations = (() => {
      if (formik.values?.varCombinations) {
        if (type === "new") {
          let newArr: variantValue = {};
          newArr[name] = {
            isSellOnline: false,
            isDefault: false,
            isSellPos: true,
            ...(singleVid && { vid: singleVid }),
            selectedWunit: "",
            selectedDunit: "",
            weightOpen: false,
            dimensionOpen: false,
            width: "",
            weight: "",
            height: "",
            length: "",
            weightCount: ""
          };
          return newArr;
        } else if (type === "modify") {
          let newArr: variantValue = {};
          newArr[name] = { ...formik.values?.varCombinations[Object.keys(formik.values?.varCombinations)[0]] };
          return newArr;
        }
      }
      return formik.values?.varCombinations;
    })();
    formik.setFieldValue("varCombinations", updatedCombinations); // this updates Formik field

  }

  //Function used to handle the image picker actions
  const handleImage = (name: string, res?: commonPickerRes[]) => {
    switch (name) {
      case 'Camera':
      case 'StoreImageGallery':
      case 'Library':
        if (res && res.length > 0) {
          if (zenType === 'single') {
            const response = res[0]
            formik.setFieldValue('featuredImage', {
              imgKey: response?.key || "",
            })
          } else {
            const newImages = res.map((response) => ({
              imgKey: response?.key || "",
            }))
            formik?.setFieldValue('additionalImages', [...(formik?.values?.additionalImages || []), ...newImages])
          }
        }
        break;
      case 'Cancel':
        break;
    }
  }

  //Function used to add location
  const addLocation = () => {
    let newArr = [...formik?.values?.locArr]
    newArr.push({
      stock: "",
      threshold: "",
      selectedLoc: "",
      isInfinite: true,
    })
    setLocationOpen((prev) => [...prev, false])
    formik?.setFieldValue('locArr', newArr)
    scrollRef?.current?.scrollToEnd()
  }

  //Function used to remove the combination
  const removeLocation = (index: number) => {
    let newArr = [...formik?.values?.locArr]
    newArr.splice(index, 1)
    formik.setFieldValue('locArr', newArr)
    setLocationOpen(prev => {
      let arr = [...prev]
      arr.splice(index, 1)
      return arr
    })
  }

  return (
    <ThemeConsumer>
      {({ theme }) => (
        <KeyboardAvoidingView style={theme?.addEditProductStyle.flex}>
          <ScrollView
            ref={scrollRef}
            style={theme?.addEditProductStyle.scrollViewStyle}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={theme?.addEditProductStyle.scrollViewContentContainer}>
            <View style={[theme?.addEditProductStyle.flex, { flexDirection: width > height ? 'row' : 'column', },
              /**
               * webContentHeightRow: on web this row has to be able to grow past
               * the scroll viewport. `flex: 1` gives it flex-basis 0 and pins it
               * to the container's height, so the columns inside are capped at
               * the viewport and their cards overflow. Growing from a content
               * basis instead lets the row be as tall as the taller column and
               * lets the ScrollView do the scrolling.
               *
               * Platform-guarded: Android keeps `flex: 1` exactly as it is.
               */
              Platform.OS === 'web' && theme?.addEditProductStyle.webContentHeightRow]}>
              {/* general details ,price details*/}
              <View style={[theme?.addEditProductStyle.leftColumn, { flex: width > 900 ? 0.7 : 0.6 }]}>
                {/* general details */}
                <View style={[theme?.addEditProductStyle.generalDetailsView, theme?.addEditProductStyle.generalDetailsCard]}>
                  <View pointerEvents={!isProductWrite ? "box-only" : undefined}>
                    {/* General Details */}
                    <ZenText
                      content="General Details"
                      color={theme.primary}
                      style={[theme?.addEditProductStyle.headerText, { fontSize: theme?.largerFontSize }]}
                      bold={true}
                    />
                    <ZenInput
                      type="outlined"
                      label="Product Name *"
                      onChangeText={(text: string) => {
                        if (!formik?.values.isMultiVariants) {
                          if (text.length != 0) {
                            if (Object.keys(formik.values?.varCombinations).length > 0) {
                              addSingleVariant(text.trim(), "modify")
                            }
                            else {
                              addSingleVariant(text.trim(), "new")
                            }
                          }
                          else {
                            formik.setFieldValue("varCombinations", {});

                          }
                        }
                        setDupName(text.trim())
                        formik.setFieldValue('ProductName', text)
                      }}

                      onBlur={() => {
                        formik.setFieldTouched('ProductName', true)
                        formik.setFieldValue('ProductName', formik?.values.ProductName.trim())
                      }}
                      disabled={!isProductWrite}
                      errorMessage={(formik?.touched.ProductName && formik?.errors.ProductName) ? (formik?.touched.ProductName && formik?.errors.ProductName) : isDuplicateValue ? 'Product name already exists!' : undefined}
                      value={formik?.values.ProductName}
                      inputContainerStyle={theme?.addEditProductStyle.inputContainer}
                      containerStyle={theme?.addEditProductStyle.inputWrapper}
                      inputStyle={theme?.addEditProductStyle.input}
                      errorStyle={[theme?.addEditProductStyle.errorStyle, { paddingBottom: (formik?.errors?.ProductName && !formik?.isValid && formik?.touched.ProductName) || isDuplicateValue ? 20 : 0, },]}
                    />

                    <ZenInput
                      value={formik?.values.ShortDescription}
                      disabled={!isProductWrite}
                      onChangeText={(text: string) => { formik.setFieldValue('ShortDescription', text) }}
                      onBlur={() => {
                        formik.setFieldTouched('ShortDescription', true)
                        formik.setFieldValue('ShortDescription', formik?.values.ShortDescription.trim())
                      }}
                      type="outlined"
                      inputContainerStyle={theme?.addEditProductStyle.inputContainer}
                      inputStyle={theme?.addEditProductStyle.input}
                      label="Description"
                      errorMessage={
                        formik?.touched.ShortDescription && formik?.errors.ShortDescription
                          ? formik?.touched.ShortDescription && formik?.errors.ShortDescription
                          : undefined
                      }
                      errorStyle={[
                        theme?.addEditProductStyle.errorStyle,
                        {
                          paddingBottom:
                            formik?.errors?.ShortDescription &&
                              !formik?.isValid &&
                              formik?.touched.ShortDescription
                              ? 20
                              : 0,
                        },
                      ]}
                      containerStyle={[
                        theme?.addEditProductStyle
                          .generalProductDescriptionInputContainerStyle,
                      ]}
                    />

                    <View style={theme?.addEditProductStyle.generalProductBrandDropdownView}>
                      <ZenDropdown
                        closeAfterSelecting={true}
                        disabled={!isProductWrite}
                        onSelectItem={(item) => {

                          formik.setFieldValue("brand", item?.value)

                        }}
                        onPress={() => {
                          if (categoryOpen) {
                            setCategoryOpen(false)
                          }
                        }}
                        title="Brand"
                        placeholder=""
                        titleStyle={[{
                          paddingBottom: 5,
                          fontFamily: theme.medium,
                          fontSize: 14,
                          fontWeight: "normal",
                          textTransform: 'capitalize', color: theme.labelColor, marginBottom: 0
                        },]}
                        items={brandOptions}
                        setValue={() => { }}
                        multiple={false}
                        style={theme?.addEditProductStyle.input}
                        labelStyle={theme?.addEditProductStyle.labelStyle}
                        listItemLabelStyle={{ fontSize: theme?.smallerFontSize }}
                        open={brandOpen}
                        setOpen={setBrandOpen}
                        value={formik?.values.brand}
                        containerStyle={theme?.addEditProductStyle.dropdownContainer}
                        maxHeight={120}
                        searchable={true}
                        searchPlaceholder="Search Specific Brand"
                      />
                    </View>

                    <View style={theme?.addEditProductStyle.marginBottom10}>
                      <ZenDropdown
                        title={'Categories *'}
                        disabled={!isProductWrite}
                        value={formik.values.categories}
                        setValue={() => { }}
                        onPress={() => formik?.setFieldTouched("categories", true)}
                        multipleText={selectedCategoryText}
                        onSelectItem={(data: any) => {
                          const selectedValues: any[] = Array.isArray(data) ? data.map((items: any) => items.value) : [];
                          const currentValues: any[] = formik?.values?.categories || [];
                          const isSame =
                            selectedValues.length === currentValues.length &&
                            selectedValues.every((val: any) => currentValues.includes(val));

                          if (!isSame) {
                            formik.setFieldValue("categories", selectedValues);
                            const selectedLabels: string[] = Array.isArray(data)
                              ? data.map((item: any) => item?.label as string).filter(Boolean)
                              : [];
                            setMultiCategory(selectedLabels);
                          }
                        }}
                        placeholder=""
                        titleStyle={[{
                          paddingBottom: 5,
                          fontFamily: theme.medium,
                          color: theme.lightDark,
                          fontSize: theme?.smallerFontSize,
                          fontWeight: "normal",
                          textTransform: 'capitalize'
                        }]}
                        searchable
                        items={categoryOptions}
                        multiple={true}
                        labelStyle={theme?.addEditProductStyle.mediumLabelStyle}
                        listItemLabelStyle={{ fontSize: theme?.smallerFontSize }}
                        open={categoryOpen}
                        setOpen={setCategoryOpen}
                        maxHeight={120}
                        style={theme?.addEditProductStyle.input}
                      />
                      {formik?.touched.categories && formik?.errors.categories ? (
                        <ZenText content={formik?.errors?.categories} color={theme.red} size={theme?.errorFontSize} />
                      ) : null}
                    </View>

                    <View
                      style={[
                        theme?.addEditProductStyle
                          .generalProductWeightDropdownView, {
                          flex: 1,
                          gap: 10
                        }
                      ]}>
                      <ZenInput
                        containerStyle={theme?.addEditProductStyle.flex07}
                        disabled={!isProductWrite}
                        keyboardType="numeric"
                        returnKeyType='done'
                        value={String(formik?.values.ProductUnitCount)}
                        onChangeText={(text: string) => { formik?.setFieldValue('ProductUnitCount', text) }}
                        type="outlined"
                        label="Product Unit Count *"
                        rightIcon={
                          <ZenToolTip
                            content={
                              <ZenText
                                content="This refers to the amount of a specific product contained in a single unit or package."
                                size={theme?.badgeFontSize}
                                color={theme?.dark}
                              />
                            }
                            height={70}
                            popover={
                              <Pressable>
                                <ZenIcon
                                  name="exclamationcircle"
                                  type="antdesign"
                                  size={14}
                                  color={theme?.primary}
                                  style={{ marginLeft: -12 }}
                                />
                              </Pressable>
                            }
                            width={280}
                            backgroundColor={theme?.lightDark}
                            popoverStyle={{ elevation: 4, bottom: 10 }}
                          />
                        }
                        inputStyle={theme?.addEditProductStyle.input}
                        inputContainerStyle={{
                          paddingHorizontal: 10,
                          borderWidth: 1,
                          height: 40,
                          borderColor: theme.borderColor,
                          paddingStart: Platform.OS === 'ios' ? 10 : null,
                        }}
                        errorMessage={
                          formik?.touched.ProductUnitCount && formik?.errors.ProductUnitCount
                            ? formik?.touched.ProductUnitCount && formik?.errors.ProductUnitCount
                            : undefined
                        }
                        errorStyle={[
                          theme?.addEditProductStyle.errorStyle,
                          {
                            paddingBottom:
                              formik?.errors?.ProductUnitCount &&
                                !formik?.isValid &&
                                formik?.touched.ProductUnitCount
                                ? 20
                                : 0,
                          },
                        ]}
                      />

                      <View
                        style={[theme?.addEditProductStyle.weightUnitContainer, {
                          zIndex: Platform?.OS == 'ios' ? 1 : undefined,
                        }]}>
                        <ZenDropdown
                          placeholder="Weight Unit"
                          disabled={!isProductWrite}
                          items={weightOptions}
                          setValue={() => { }}
                          multiple={false}
                          style={theme?.addEditProductStyle.weightUnitDropdown}
                          listItemLabelStyle={{
                            fontSize: theme?.smallerFontSize,
                          }}
                          labelStyle={{
                            fontSize: theme?.smallerFontSize,
                            color: theme?.dark,
                            fontFamily: theme?.medium,
                          }}
                          closeAfterSelecting={true}
                          value={formik.values.weightUnit!}
                          onSelectItem={(item) => {
                            formik.setFieldValue("weightUnit", item?.value)
                          }}
                          searchable
                          open={weightOpen}
                          setOpen={setWeightOpen}

                          maxHeight={120}
                        />
                      </View>
                      {(formik?.values.ProductUnitCount && (formik.values.weightUnit) && !formik?.errors.ProductUnitCount) ? <ZenBadge badgeName={`Per ${Number(formik?.values.ProductUnitCount) > 1 ? parseFloat(formik?.values.ProductUnitCount as string) : ''} ${(weightOptions.find(obj => obj.value === formik.values.weightUnit) || {}).label}`}
                        badgeColor={theme.secondary}
                        badgeTextColor={theme.light}
                        badgeTextSize={theme?.smallerFontSize}
                        badgeTextStyle={{ fontFamily: theme.bold }}
                      /> : null}
                    </View>
                    <ZenText
                      content="Weight & Dimensions"
                      color={theme.primary}
                      bold={true}
                      style={{ fontSize: theme?.mediumFontSize, marginTop: 8 }}
                    />
                    {!formik?.values?.isMultiVariants ? <>
                      <ZenInput
                        type="outlined"
                        disabled={!isProductWrite}
                        inputStyle={{ height: 40 }}
                        label="Weight"
                        keyboardType="numeric"
                        onChangeText={formik?.handleChange('weight')}
                        onBlur={formik?.handleBlur('weight')}
                        value={
                          formik?.values?.weight
                            ? String(formik?.values?.weight)
                            : ''
                        }
                        errorMessage={
                          formik?.errors?.weight &&
                            formik?.touched?.weight
                            ? formik?.errors?.weight
                            : ''
                        }
                        errorStyle={[
                          theme.addEditProductStyle.errorStyle,
                          {
                            paddingBottom:
                              formik?.errors?.weight &&
                                !formik?.isValid &&
                                formik?.touched.weight
                                ? 20
                                : 0,
                          },
                        ]}
                        containerStyle={[
                          theme.addEditProductStyle
                            .generalProductUnitCountContainerStyle,
                        ]}
                      />

                      <ZenText
                        content="Dimensions"
                        style={[{ marginBottom: 5 }, Platform.OS === 'web' && theme?.addEditProductStyle.webFieldLabel]}
                        size={'small'}
                      />
                      <View
                        style={[
                          theme.addEditProductStyle
                            .generalProductWeightDropdownView,
                          {
                            gap: 5,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          },
                        ]}>
                        <ZenInput
                          type="outlined"
                          disabled={!isProductWrite}
                          placeholder="Length"
                          onChangeText={formik?.handleChange(
                            'length',
                          )}
                          keyboardType="numeric"
                          onBlur={formik?.handleBlur('length')}
                          inputContainerStyle={theme?.addEditProductStyle.inputContainer}
                          inputStyle={theme?.addEditProductStyle.input}
                          errorMessage={
                            formik?.errors?.length &&
                              formik?.touched?.length
                              ? formik?.errors?.length
                              : ''
                          }
                          errorStyle={[
                            theme.addEditProductStyle.errorStyle,
                            {
                              paddingBottom:
                                formik?.errors?.length &&
                                  !formik?.isValid &&
                                  formik?.touched.length
                                  ? 20
                                  : 0,
                            },
                          ]}
                          containerStyle={[
                            theme.addEditProductStyle
                              .generalProductDimensionContainerStyle,
                          ]}
                        />
                        <ZenText content="*" />
                        <ZenInput
                          type="outlined"
                          disabled={!isProductWrite}
                          placeholder="Width"
                          inputStyle={{ height: 40 }}
                          keyboardType="numeric"
                          onChangeText={formik?.handleChange(
                            'width',
                          )}
                          onBlur={formik?.handleBlur('width')}
                          inputContainerStyle={{ paddingHorizontal: 8 }}
                          errorMessage={
                            formik?.errors?.width &&
                              formik?.touched?.width
                              ? formik?.errors?.width
                              : ''
                          }
                          errorStyle={[
                            theme.addEditProductStyle.errorStyle,
                            {
                              paddingBottom:
                                formik?.errors?.width &&
                                  !formik?.isValid &&
                                  formik?.touched.width
                                  ? 20
                                  : 0,
                            },
                          ]}
                          containerStyle={[
                            theme.addEditProductStyle
                              .generalProductDimensionContainerStyle,
                          ]}
                        />
                        <ZenText content="*" />
                        <ZenInput
                          type="outlined"
                          disabled={!isProductWrite}
                          keyboardType="numeric"
                          inputStyle={{ height: 40 }}
                          placeholder="Height"
                          onChangeText={formik?.handleChange(
                            'height',
                          )}
                          onBlur={formik?.handleBlur(
                            'height',
                          )}
                          errorMessage={
                            formik?.errors?.height &&
                              formik?.touched?.height
                              ? formik?.errors?.height
                              : ''
                          }
                          errorStyle={[
                            theme.addEditProductStyle.errorStyle,
                            {
                              paddingBottom:
                                formik?.errors?.height &&
                                  !formik?.isValid &&
                                  formik?.touched.height
                                  ? 20
                                  : 0,
                            },
                          ]}
                          inputContainerStyle={{
                            paddingHorizontal: 8
                          }}
                          containerStyle={[
                            theme.addEditProductStyle
                              .generalProductDimensionContainerStyle,
                          ]}
                        />
                      </View>
                      {/* Dimension Unit Dropdown */}
                      <View
                        style={[theme?.addEditProductStyle.weightUnitContainer, { marginBottom: 15 }]}>
                        <ZenDropdown
                          searchable
                          disabled={!isProductWrite}
                          placeholder="Dimension Unit"
                          items={dimensionOptions}
                          multiple={false}
                          setValue={() => {
                          }}
                          dropDownContainerStyle={{
                            position: 'relative',
                            top: 0,
                          }}
                          open={isDimensionOpen}
                          setOpen={setIsDimensionOpen}
                          maxHeight={120}
                          value={formik?.values?.dimensionUnit}
                          onSelectItem={data => {
                            formik?.setFieldValue(
                              'dimensionUnit',
                              data.value,
                            );
                          }}
                          style={theme?.addEditProductStyle.input}
                          listItemLabelStyle={{
                            fontSize: theme?.smallerFontSize,
                          }}
                          labelStyle={{
                            fontSize: theme?.smallerFontSize,
                            color: theme?.dark,
                            fontFamily: theme?.medium,
                          }}
                        />
                      </View>
                    </> : <ZenText
                      content="You can give Weight & Dimensions for variants in Variants tab."
                      color={theme.lightDark}
                      style={theme?.addEditProductStyle.smallTextPadding}
                    />}


                  </View>
                </View>

                {/* Price Details */}
                <View style={[theme?.addEditProductStyle.generalDetailsView, theme?.addEditProductStyle.cardPadding]}>
                  <View pointerEvents={!isProductWrite ? "box-only" : undefined}>
                    {/* Price Details */}
                    <ZenText
                      content="Price Details"
                      color={theme.primary}
                      style={[theme?.addEditProductStyle.headerText, { fontSize: theme?.largerFontSize }]}
                      bold={true}
                    />
                    <ZenText
                      content="Sale information"
                      style={theme?.addEditProductStyle.subHeaderText}
                      color={theme.lightDark}
                      bold={true}
                    />
                    {!formik?.values.isMultiVariants ? (
                      <>
                        <ZenInput
                          type="outlined"
                          disabled={!isProductWrite}
                          inputStyle={theme?.addEditProductStyle.inputPaddingLeft}
                          label="Selling Price *"
                          keyboardType="numeric"
                          returnKeyType='done'
                          value={String(formik?.values.sellingPrice)}
                          inputContainerStyle={theme?.addEditProductStyle.inputContainer10}
                          onChangeText={(text: string) => {
                            formik?.setFieldTouched('MRP', true)
                            formik?.setFieldTouched('WholesalePrice', true)
                            formik?.setFieldValue('sellingPrice', text)
                          }}
                          onBlur={formik.handleBlur('sellingPrice')}
                          errorMessage={
                            formik?.touched.sellingPrice && formik?.errors.sellingPrice
                              ? formik?.touched.sellingPrice && formik?.errors.sellingPrice
                              : undefined
                          }
                          errorStyle={[
                            theme.addEditProductStyle.errorStyle,
                            {
                              paddingBottom:
                                formik?.errors?.sellingPrice &&
                                  !formik?.isValid &&
                                  formik?.touched.sellingPrice
                                  ? 20
                                  : 0,
                            },
                          ]}
                          containerStyle={[
                            theme.addEditProductStyle.variantInputContainerStyle,
                          ]}
                          leftIcon={
                            <ZenText
                              content="INR"
                              style={{
                                color: theme.primary,
                                fontSize: theme?.smallHeaderFontSize,
                                fontFamily: theme?.bold,
                              }}
                            />
                          }
                          leftIconStyle={
                            theme.addEditProductStyle.leftIconContainerStyle
                          }
                        />
                        {/* MRP */}
                        <ZenInput
                          keyboardType="numeric"
                          type="outlined"
                          disabled={!isProductWrite}
                          inputStyle={theme?.addEditProductStyle.inputPaddingLeft}
                          inputContainerStyle={theme?.addEditProductStyle.inputContainer10}
                          onBlur={formik.handleBlur('MRP')}
                          errorMessage={
                            formik?.touched.MRP && formik?.errors.MRP
                              ? formik?.touched.MRP && formik?.errors.MRP
                              : undefined
                          }
                          returnKeyType='done'
                          value={String(formik?.values.MRP)}
                          onChangeText={formik.handleChange('MRP')}
                          label="MRP"
                          containerStyle={[
                            theme.addEditProductStyle.variantInputContainerStyle,
                          ]}
                          errorStyle={[
                            theme.addEditProductStyle.errorStyle,
                            {
                              paddingBottom:
                                formik?.errors?.MRP &&
                                  !formik?.isValid &&
                                  formik?.touched.MRP
                                  ? 20
                                  : 0,
                            },
                          ]}
                          leftIcon={
                            <ZenText
                              content="INR"
                              style={theme?.addEditProductStyle.currencyText}
                            />
                          }
                          leftIconStyle={
                            theme.addEditProductStyle.leftIconContainerStyle
                          }
                          rightIcon={
                            <ZenToolTip
                              content={
                                <ZenText
                                  content="To show an offer price for this product, move the Product's original price into MRP and enter a lower-price value in Selling Price."
                                  size={theme?.badgeFontSize}
                                  color={theme?.dark}
                                />
                              }
                              height={70}
                              popover={
                                <Pressable>
                                  <ZenIcon
                                    name="information"
                                    type="material-community"
                                    size={16}
                                    color={theme?.primary}
                                    style={{ marginLeft: 5 }}
                                  />
                                </Pressable>
                              }
                              width={300}
                              backgroundColor={theme?.lightBackgroundColor}
                              popoverStyle={{ elevation: 4, bottom: 10 }}
                            />

                          }
                        />

                        <ZenInput
                          keyboardType="numeric"
                          disabled={!isProductWrite}
                          returnKeyType='done'
                          value={String(formik?.values.WholesalePrice)}
                          onChangeText={formik.handleChange('WholesalePrice')}
                          type="outlined"
                          label="Wholesale Price"
                          inputStyle={theme?.addEditProductStyle.inputPaddingLeft}
                          inputContainerStyle={theme?.addEditProductStyle.inputContainer10}
                          onBlur={formik.handleBlur('WholesalePrice')}
                          errorMessage={
                            formik?.touched.WholesalePrice && formik?.errors.WholesalePrice
                              ? formik?.touched.WholesalePrice && formik?.errors.WholesalePrice
                              : undefined
                          }
                          errorStyle={[
                            theme.addEditProductStyle.errorStyle,
                            {
                              paddingBottom:
                                formik?.errors?.WholesalePrice &&
                                  !formik?.isValid &&
                                  formik?.touched.WholesalePrice
                                  ? 20
                                  : 0,
                            },
                          ]}
                          containerStyle={[
                            theme.addEditProductStyle
                              .variantInputContainerStyle,
                            // {paddingHorizontal: 10},
                          ]}
                          leftIcon={
                            <ZenText
                              content="INR"
                              style={theme?.addEditProductStyle.currencyText}
                            />
                          }
                          leftIconStyle={
                            theme.addEditProductStyle.leftIconContainerStyle
                          }
                        />
                      </>
                    ) : (
                      <ZenText
                        content="You can give sale information for variants in Variants tab."
                        color={theme.lightDark}
                        style={theme?.addEditProductStyle.smallText}
                      />
                    )}
                    <ZenText
                      content="Purchase information"
                      style={theme?.addEditProductStyle.subHeaderTextMedium}
                      color={theme.lightDark}
                      bold={true}
                    />
                    {
                      !formik?.values?.isMultiVariants ? (
                        <>
                          <ZenInput
                            keyboardType="numeric"
                            disabled={!isProductWrite}
                            returnKeyType='done'
                            type="outlined"
                            label="Cost Price *"
                            value={String(formik?.values.costPrice)}
                            onChangeText={formik.handleChange('costPrice')}
                            inputStyle={theme?.addEditProductStyle.inputPaddingLeft}
                            inputContainerStyle={theme?.addEditProductStyle.inputContainer10}
                            onBlur={formik.handleBlur('costPrice')}
                            errorMessage={
                              formik?.touched.costPrice && formik?.errors.costPrice
                                ? formik?.touched.costPrice && formik?.errors.costPrice
                                : undefined
                            }
                            errorStyle={[
                              theme.addEditProductStyle.errorStyle,
                              {
                                paddingBottom:
                                  formik?.errors?.costPrice &&
                                    !formik?.isValid &&
                                    formik?.touched.costPrice
                                    ? 20
                                    : 0,
                              },
                            ]}
                            containerStyle={[
                              theme.addEditProductStyle
                                .variantInputContainerStyle,
                              // {paddingHorizontal: 10},
                            ]}
                            leftIcon={
                              <ZenText
                                content="INR"
                                style={theme?.addEditProductStyle.currencyText}
                              />
                            }
                            leftIconStyle={
                              theme.addEditProductStyle.leftIconContainerStyle
                            }
                          />

                        </>
                      ) : (<ZenText
                        content="You can give purchase information for variants in Variants tab."
                        color={theme.lightDark}
                        style={theme?.addEditProductStyle.smallText}
                      />
                      )
                    }

                  </View>
                </View>
              </View>
              {/* other details and image */}
              <View style={[theme?.addEditProductStyle.rightColumn, { flex: width > 900 ? 0.3 : 0.4 }]}>
                {/* Image Card */}
                <View style={[theme?.addEditProductStyle.viewStyle, theme?.addEditProductStyle.cardPadding]}>
                  <View style={[theme?.addEditProductStyle.imageHeader, { justifyContent: 'flex-start' }]}>
                    <ZenText
                      content={'Product Images'}
                      size={16}
                      color={theme?.primary}
                    />

                  </View>
                  <View style={[theme?.addEditProductStyle.imageContainer, { justifyContent: (!formik?.values.isMultiVariants && formik.values.additionalImages.length < 5) ? 'space-between' : 'center' }]}>
                    {formik.values.featuredImage?.imgKey ?
                      <Pressable style={theme?.addEditProductStyle.imageBox} onPress={() => { setZenType("single"), bottomRef?.current?.open() }}>
                        {isProductWrite && <ZenIcon
                          type="material-community"
                          name="close-circle"
                          disabled={imgUploading || isProductWrite}
                          style={theme.addEditProductStyle.imgClose}
                          onPress={() => {
                            if (formik?.values?.featuredImage?.edit) {
                              setDelMain([{
                                "image": formik?.values?.featuredImage?.imgKey,
                                "fileName": formik?.values?.featuredImage?.imgKey?.split('/').pop(),
                                "isDelete": true
                              }])
                            }
                            formik.setFieldValue('featuredImage', null)
                            setMainImage([])
                          }}
                        />}
                        <ZenIcon
                          type="material-community"
                          name={'cloud-check'} color={theme.activeColor} size={22}
                          style={theme.addEditProductStyle.imgCloud}
                        />
                        <Image
                          style={[theme?.addEditProductStyle.uploadedImage, { width: 120, height: 100 }]}
                          resizeMode='contain'
                          source={{
                            uri: formik?.values?.featuredImage?.imgKey
                              ? formik.values.featuredImage.imgKey.includes("file:")
                                ? formik.values.featuredImage.imgKey
                                : config.AWSImageUrl + formik.values.featuredImage.imgKey
                              : formik.values.featuredImage?.imgKey
                              ?? config.AWSImageUrl + "mobileAdmin/upload.png"
                          }}

                        />

                      </Pressable> :
                      <Pressable
                        style={theme?.addEditProductStyle.imageBox}
                        disabled={imgUploading || !isProductWrite} onPress={() => { setZenType("single"), bottomRef?.current?.open() }}>
                        <ZenIcon
                          name="camera"
                          type="material-community"
                          size={width > height ? 35 : 27}
                          color={theme.primary}
                        />
                        <ZenText
                          content={'Upload Main Image'}
                          style={theme?.addEditProductStyle.centerText}
                          numberOfLines={2}
                          color={theme?.primary}
                          size={'small'}
                        />
                      </Pressable>
                    }
                    {(!formik?.values.isMultiVariants && formik.values.additionalImages.length < 5) ?

                      <Pressable
                        style={theme?.addEditProductStyle.imageBox}
                        disabled={imgUploading || !isProductWrite}
                        onPress={() => { setZenType("multi"), bottomRef?.current?.open() }}>
                        <ZenIcon
                          name="plus"
                          type="feather"
                          size={width > height ? 30 : 22}
                          color={theme.primary}
                        />
                        <ZenText
                          content={'Other Angle Images'}
                          style={theme?.addEditProductStyle.centerText}
                          numberOfLines={2}
                          color={theme?.primary}
                          size={'small'}
                        />
                      </Pressable>
                      : undefined}
                  </View>
                  {formik.values.additionalImages?.length ? <View style={[theme.addEditProductStyle.multiImageContainer, { borderColor: theme.borderColor }]} >
                    {formik?.values?.additionalImages?.map((list, index) => {
                      return (
                        <View key={index} style={theme.addEditProductStyle.multiImgView}>
                          <ZenIcon
                            type='material-community'
                            name='close-circle' color={theme.lightDark} size={21}
                            style={theme.addEditProductStyle.imgClose}
                            disabled={imgUploading || !isProductWrite}
                            onPress={() => {
                              if (list?.id) {
                                formik.setFieldValue("removedVariantImagesUrl", [...formik?.values?.removedVariantImagesUrl, { id: list?.id }])
                              }
                              const tempAdditionImg = [...formik.values.additionalImages]
                              tempAdditionImg.splice(index, 1);
                              formik.setFieldValue('additionalImages', tempAdditionImg)
                              const tempMultiImages = [...multiImages]
                              tempMultiImages.splice(index, 1);
                              setMultiImages(tempMultiImages)
                            }}
                          />
                          <ZenIcon
                            type='material-community'
                            name={'cloud-check'} color={theme.activeColor} size={20}
                            style={theme.addEditProductStyle.imgCloud}
                          />
                          <Image
                            style={[theme?.addEditProductStyle.uploadedImage, {
                              width: width > height ? 60 : 50,
                              height: width > height ? 80 : 30,
                            }]}
                            resizeMode='contain'
                            source={{
                              uri:
                                list?.imgKey
                                  ? list?.imgKey.includes("file:")
                                    ? list?.imgKey
                                    : config.AWSImageUrl + list?.imgKey
                                  : list?.imgKey
                                    ? list?.imgKey
                                    : config.AWSImageUrl + "mobileAdmin/upload.png"
                            }}
                          />

                        </View>
                      );
                    })}
                  </View> : null}
                </View>
                {/* Other Details */}
                <View style={[theme?.addEditProductStyle.viewStyle, theme?.addEditProductStyle.cardPadding]}>
                  <ZenText
                    content="Other Details"
                    color={theme.primary}
                    style={theme?.addEditProductStyle.mediumText}
                    bold={true}
                  />
                  {(!formik?.values.isMultiVariants) ? (<View style={{}}>
                    {/* <ZenInput
                      type="outlined"
                      label="SKU"
                      disabled={!isProductWrite}
                      inputStyle={theme?.addEditProductStyle.input}
                      value={formik?.values.Sku}
                      onChangeText={(text: string) => {
                        setSku(text.trim())
                        formik.setFieldValue('Sku', text)
                      }}
                      onBlur={() => {
                        formik.setFieldTouched('Sku', true)
                        formik.setFieldValue('Sku', formik?.values.Sku.trim())
                      }}
                      errorMessage={(formik?.touched.Sku && formik?.errors.Sku) ? (formik?.touched.Sku && formik?.errors.Sku) : isDuplicateSku ? 'SKU Already Exists' : undefined}
                      errorStyle={[
                        theme.addEditProductStyle.errorStyle,
                        {
                          paddingBottom:
                            formik?.errors?.Sku &&
                              !formik?.isValid &&
                              formik?.touched.Sku
                              ? 20
                              : 0,
                        },
                      ]}
                      containerStyle={[
                        theme?.addEditProductStyle.marginTop15,
                        theme.addEditProductStyle.variantInputContainerStyle,
                      ]}
                      rightIcon={
                        <ZenToolTip
                          content={
                            <ZenText
                              content="An alphanumeric code that identifies a product and helps you track inventory for the store."
                              size={theme?.badgeFontSize}
                              color={theme?.dark}
                            />
                          }
                          height={width > 600 ? 80 : 70}
                          popover={
                            <Pressable>
                              <ZenIcon
                                name="exclamationcircle"
                                type="antdesign"
                                size={14}
                                color={theme?.primary}
                                style={{ marginLeft: -12 }}
                              />
                            </Pressable>
                          }
                          width={280}
                          backgroundColor={theme?.lightDark}
                          popoverStyle={{ elevation: 4, bottom: 10 }}
                        />
                      }
                    /> */}
                    <ProductBarcodeGenerator
                      sku={formik?.values.Sku}
                      upc={formik?.values.Upc}
                      productName={formik?.values.ProductName}
                      categoryName={skuCategoryName}
                      brandName={skuBrandName}
                      disabled={!isProductWrite}
                      readOnly={hasSavedSku}
                      onSkuChange={(newSku: string) => {
                        setSku(newSku.trim())
                        formik.setFieldValue('Sku', newSku.trim())
                        formik.setFieldTouched('Sku', true)
                      }}
                    />


                    <ZenInput
                      type="outlined"
                      disabled={!isProductWrite}
                      inputStyle={theme?.addEditProductStyle.input}
                      label="UPC / Barcode"
                      keyboardType="numeric"
                      returnKeyType='done'
                      value={formik?.values.Upc}
                      onChangeText={(text: string) => { formik.setFieldValue('Upc', text) }}
                      onBlur={() => {
                        formik.setFieldValue('Upc', formik?.values.Upc.trim())
                      }}
                      errorMessage={
                        formik?.errors?.Upc &&
                          formik?.touched?.Upc
                          ? formik?.errors?.Upc
                          : ''
                      }
                      errorStyle={[
                        theme.addEditProductStyle.errorStyle,
                        {
                          paddingBottom:
                            formik?.errors?.Upc &&
                              !formik?.isValid &&
                              formik?.touched.Upc
                              ? 20
                              : 0,
                        },
                      ]}
                      containerStyle={[
                        theme.addEditProductStyle.variantInputContainerStyle,
                      ]}
                      rightIcon={
                        <ZenToolTip
                          content={
                            <ZenText
                              content="Universal Product code is a 12-digit barcode that identifies products and their manufacturers, with the first six digits identifying the manufacturer and the last six digits identifying the product."
                              size={theme?.badgeFontSize}
                              color={theme?.dark}
                              numberOfLines={2}
                            />
                          }
                          height={70}
                          popover={
                            <Pressable>
                              <ZenIcon
                                name="exclamationcircle"
                                type="antdesign"
                                size={14}
                                color={theme?.primary}
                                style={{ marginLeft: -12 }}
                              />
                            </Pressable>
                          }
                          width={300}
                          backgroundColor={theme?.lightBackgroundColor}
                          popoverStyle={{ elevation: 4, bottom: 10 }}
                        />
                      }
                    />
                    {/* <ZenInput
                      type="outlined"
                      disabled={!isProductWrite}
                      inputStyle={theme?.addEditProductStyle.input}
                      label="UPC / Barcode"
                      keyboardType="numeric"
                      returnKeyType='done'
                      value={formik?.values.Upc}
                      onChangeText={(text: string) => {
                        formik.setFieldValue('Upc', text);
                      }}
                      onBlur={() => {
                        formik.setFieldTouched('Upc', true);
                        formik.setFieldValue('Upc', formik?.values.Upc || '');
                      }}
                      containerStyle={[
                        theme.addEditProductStyle.variantInputContainerStyle,
                      ]}
                      rightIcon={
                        <ZenToolTip
                          content={
                            <ZenText
                              content="Universal Product Code / EAN is a 13-digit barcode that identifies products and their manufacturers, with the first digits identifying the country/manufacturer and the final digit serving as the checksum."
                              size={theme?.badgeFontSize}
                              color={theme?.dark}
                              numberOfLines={2}
                            />
                          }
                          height={70}
                          popover={
                            <Pressable>
                              <ZenIcon
                                name="exclamationcircle"
                                type="antdesign"
                                size={14}
                                color={theme?.primary}
                                style={{ marginLeft: -12 }}
                              />
                            </Pressable>
                          }
                          width={300}
                          backgroundColor={theme?.lightBackgroundColor}
                          popoverStyle={{ elevation: 4, bottom: 10 }}
                        />
                      }
                    /> */}

                  </View>
                  ) : <ZenText
                    content="You can give the other details for variants in Variants tab."
                    style={theme?.addEditProductStyle.smallFontSize}
                    color={theme.lightDark}
                  />
                  }
                </View>
                {/* Tax Details */}
                <View style={[theme?.addEditProductStyle.viewStyle, theme?.addEditProductStyle.cardPadding]}>
                  <ZenText
                    content="Tax Details"
                    color={theme.primary}
                    style={theme?.addEditProductStyle.mediumText}
                    bold={true}
                  />
                  <ZenCheckBox
                    disabled={!isProductWrite}
                    onPress={() => {
                      formik.setFieldValue("isTaxable", true)
                      let taxIds = []
                      if (productId) {
                        if (formik.values.taxClasses?.length == 0) {
                          taxIds = [...defaultTax]
                        } else {
                          taxIds = [...taxCopy]
                        }
                      }
                      else {
                        taxIds = [...defaultTax]
                      }
                      formik.setFieldValue("taxClasses", taxIds)
                      let multiTextArray = []
                      let tempArray: string[] = []
                      taxClassOptions?.find((items) => {
                        taxIds?.find((value) => {
                          if (items.value === value) {
                            multiTextArray.push(items?.label);
                            tempArray = multiTextArray?.filter((item, i, newArray) => newArray.indexOf(item) === i,);
                          }
                          setMultiTax(tempArray);
                        });
                      })
                    }}
                    titleStyle={{ fontSize: theme?.smallHeaderFontSize, paddingLeft: 5, color: theme?.lightDark, }}
                    title={'Taxable'}
                    checked={formik.values.isTaxable}
                    checkedColor={theme.primary}
                    containerStyle={{ marginVertical: 2, marginTop: 12, }}
                  />
                  {formik.values.isTaxable && (
                    <View style={{ marginVertical: 8 }}>
                      <ZenDropdown
                        title="Choose Tax Class *"
                        disabled={!isProductWrite}
                        searchable
                        searchPlaceholder="Search Tax"
                        titleStyle={{ marginBottom: 0 }}
                        closeAfterSelecting={true}
                        items={taxClassOptions}
                        onClose={() => { formik.setFieldTouched('ChooseTaxClass', true) }}
                        setValue={() => { }}
                        multiple={true}
                        multipleText={selectedTaxText}
                        placeholder=""
                        renderListItem={({ item, ...props }: DropdownRenderItemInterface) => {
                          return (
                            <TouchableOpacity
                              style={{
                                flexDirection: 'row',
                                padding: 10,
                                justifyContent: 'space-between',
                              }}
                              onPress={() => {
                                props?.onPress!(item)
                              }}
                            >
                              <ZenText
                                style={{
                                  fontSize: theme?.smallHeaderFontSize,
                                }}
                                color={
                                  props?.isSelected
                                    ? theme.primary
                                    : theme.lightDark
                                }
                                content={item?.label}
                              />
                              {!item?.isEnabled ? (
                                <ZenText
                                  style={{ fontSize: theme?.smallFontSize }}
                                  color={theme.red}
                                  content={'Not Available'}
                                />
                              ) : props?.isSelected ? (
                                <ZenIcon
                                  size={15}
                                  name="check"
                                  type="entypo"
                                  color={theme.primary}
                                  style={{ width: 20, height: 20 }}
                                />
                              ) : undefined}
                            </TouchableOpacity>
                          );
                        }}
                        onSelectItem={(items: any) => {
                          const selectedValues: number[] = Array.isArray(items)
                            ? items.map((item: any) => item?.value as number)
                            : [];
                          const currentValues: number[] = formik?.values?.taxClasses || [];
                          const isSame =
                            selectedValues.length === currentValues.length &&
                            selectedValues.every((val) => currentValues.includes(val));

                          if (!isSame) {
                            formik.setFieldValue("taxClasses", selectedValues);
                            setTaxCopy(selectedValues);
                            const selectedLabels: string[] = Array.isArray(items)
                              ? items.map((item: any) => item?.label as string).filter(Boolean)
                              : [];
                            setMultiTax(selectedLabels);
                          }
                        }}
                        open={taxOpen}
                        setOpen={setTaxOpen}
                        listItemLabelStyle={{
                          fontSize: theme?.smallerFontSize,
                        }}
                        labelStyle={theme?.addEditProductStyle.mediumLabelStyle}
                        onOpen={() => {
                          formik.setFieldTouched('taxClasses', true);
                        }}
                        value={formik.values.taxClasses}
                        style={{
                          borderColor: theme?.lightGrey,
                          marginVertical: 5,
                          height: 40,
                        }}
                        maxHeight={150}
                        dropDownContainerStyle={{ position: 'relative', top: -5 }}
                      />

                      {formik?.touched.ChooseTaxClass && formik.values.taxClasses.length == 0 ? (
                        <ZenText
                          style={{
                            fontSize: theme?.errorFontSize,
                            fontFamily: theme?.medium,
                            color: theme?.red,
                          }}
                          content={"Tax Class is required"}
                        />
                      ) : null}

                    </View>
                  )}

                  <ZenCheckBox
                    disabled={!isProductWrite}
                    onPress={() => {
                      formik.setFieldTouched('ChooseTaxClass', false)
                      setTaxOpen(false)

                      formik.setFieldValue("isTaxable", false)
                      let taxIds = []
                      if (productId) {
                        if (taxCopy.length == 0) {
                          taxIds = [...defaultTax]
                        }
                        else {
                          taxIds = [...taxCopy]
                        }
                      }
                      else {
                        taxIds = [...defaultTax]
                      }
                      formik.setFieldValue("taxClasses", taxIds)
                      let multiTextArray = []
                      let tempArray: string[] = []
                      taxClassOptions?.find((items) => {
                        taxIds?.find((value) => {
                          if (items.value === value) {
                            multiTextArray.push(items?.label);
                            tempArray = multiTextArray?.filter(
                              (item, i, newArray) =>
                                newArray.indexOf(item) === i,
                            );
                          }
                          setMultiTax(tempArray);
                        });
                      });
                    }}
                    titleStyle={{
                      fontSize: theme?.smallHeaderFontSize,
                      paddingLeft: 5,
                      color: theme?.lightDark,
                    }}
                    title={'Non - Taxable'}
                    checked={!formik.values.isTaxable}
                    checkedColor={theme?.primary}
                  />
                </View>
                <View style={[theme.addEditProductStyle.viewStyle, { marginTop: 10, padding: 15, gap: 10, }]}>
                  <ZenText
                    content="Product Returnable"
                    color={theme?.primary}
                    style={{ fontSize: theme?.mediumFontSize }}
                    bold={true}
                  />
                  <ZenCheckBox
                    disabled={!isProductWrite}
                    onPress={() => formik.setFieldValue('isReturnable', !formik?.values?.isReturnable,)}
                    checked={formik?.values?.isReturnable}
                    titleStyle={{ fontSize: theme?.smallHeaderFontSize, paddingLeft: 5, color: theme?.lightDark, }}
                    title={'Accept return for this product'}
                    checkedColor={theme?.primary}
                    containerStyle={{ marginVertical: 2, marginTop: 12, }}
                  />
                  <ZenText
                    content="Product Variants"
                    color={theme?.primary}
                    bold={true}
                    style={{ fontSize: theme?.mediumFontSize, marginTop: 8 }}
                  />
                  <ZenCheckBox
                    disabled={!isProductWrite}
                    onPress={() => {
                      if (formik?.values.isMultiVariants) {
                        if (productId) {
                          setIsClearVar(true)
                        }
                        else {
                          if (formik?.values?.ProductName.length > 0) {
                            if (productId) {
                              let tempIds = (rvarIds[0] == singleVid) ? [] : [...rvarIds]
                              Object.keys(formik.values?.varCombinations).map((key) => {
                                if (formik.values?.varCombinations?.[key]?.vid) {
                                  tempIds.push(formik.values?.varCombinations?.[key].vid)
                                }
                              })
                              setRvarIds(tempIds)
                            }
                            addSingleVariant(formik?.values?.ProductName, "new")
                          }
                          else {
                            formik.setFieldValue("varCombinations", {});

                          }
                          formik.setFieldValue("selectedVariants", [])
                          setSelectedVarObj([])
                          setChecked([])

                          formik.setFieldValue('isMultiVariants', !formik?.values?.isMultiVariants)
                          formik.setFieldValue('Sku', '')
                          formik.setFieldValue('Upc', '')
                          formik.setFieldValue('square', '')
                          formik.setFieldValue('sellingPrice', '')
                          formik.setFieldValue('WholesalePrice', '')
                          formik.setFieldValue('MRP', '')
                        }
                      }
                      else {
                        if (productId) {
                          setIsEnabVar(true)
                        }
                        else {
                          formik.setFieldValue("varCombinations", {});
                          formik.setFieldValue('isMultiVariants', !formik?.values.isMultiVariants)
                        }
                      }
                    }}
                    titleStyle={{
                      fontSize: theme?.smallHeaderFontSize,
                      paddingLeft: 5,
                      color: theme?.lightDark,
                    }}
                    title={'Add variant(s) to this product'}
                    checked={formik?.values?.isMultiVariants}
                    checkedColor={theme.primary}
                    containerStyle={{
                      marginVertical: 2,
                      marginTop: 12,
                    }}
                  />
                </View>
                <View style={[theme.addEditProductStyle.viewStyle, { marginTop: 10, padding: 15, gap: 10, }]}>
                  <ZenText
                    content="Product Availability"
                    color={theme?.primary}
                    style={{ fontSize: theme?.mediumFontSize }}
                    bold={true}
                  />
                  {!formik?.values.isMultiVariants ? <View style={{ marginBottom: 10 }}>
                    <View
                      style={
                        theme.addEditProductStyle.generalProductAvailabilityStyle
                      }>
                      <View
                        style={[
                          { right: 8 },
                          theme.addEditProductStyle.generalProductSwitchView,
                        ]}>
                        <ZenSwitch
                          disabled={!isProductWrite}
                          value={formik?.values?.sellPos}
                          activeColor={theme?.primary}
                          inActiveColor={theme?.borderColor}
                          activeThumbColor={theme?.light}
                          inactiveThumbColor={theme?.light}
                          onValueChange={() => {
                            formik.setFieldValue(
                              'sellPos',
                              !formik?.values?.sellPos,
                            );
                          }}
                          style={{ transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }] }}
                        />
                        <ZenText
                          content="POS"
                          style={{ fontSize: theme?.smallHeaderFontSize }}
                          color={theme?.lightDark}
                        />
                      </View>
                      {/* <View
                        style={
                          theme.addEditProductStyle.generalProductSwitchView
                        }>
                        <ZenSwitch
                          disabled={!isProductWrite}
                          activeColor={theme?.primary}
                          inActiveColor={theme?.borderColor}
                          activeThumbColor={theme?.light}
                          inactiveThumbColor={theme?.light}
                          onValueChange={() => {
                            formik.setFieldValue(
                              'sellOnline',
                              !formik?.values?.sellOnline,
                            );
                          }}
                          value={formik?.values?.sellOnline}
                          style={{ transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }] }}
                        />
                        <ZenText
                          content="Sell Online"
                          style={{ fontSize: theme?.smallHeaderFontSize }}
                          color={theme?.lightDark}
                        />
                      </View> */}
                    </View>
                  </View> : <ZenText
                    content="You can give Product Availability for variants in Variants tab."
                    color={theme?.lightDark}
                    style={{ fontSize: theme?.smallFontSize, paddingBottom: 10, }}
                  />}
                </View>
              </View>
            </View>
            {/* Availability Location */}
            {(!formik?.values.isMultiVariants) && <View style={[
              { backgroundColor: theme.light, marginVertical: 20, marginHorizontal: 10, marginTop: 10, padding: 15 },
              /*
               * flex: 1 lives in the platform branch rather than in the object
               * above because a later style cannot take it back: react-native-web
               * skips undefined values, so flex: undefined in a second array entry
               * leaves the first entry flex: 1 in place. Keeping it out of the web
               * branch entirely is what actually lets the card size to its content.
               */
              Platform.OS === 'web' ? theme?.addEditProductStyle.webCardAutoHeight : theme?.addEditProductStyle.flex,
            ]}>
              <View style={[theme.addEditProductStyle.rowContainer, { marginRight: 10, marginBottom: 15 }]}>
                <ZenText
                  content="Availability Location"
                  style={[{ paddingBottom: 10, fontSize: theme?.mediumFontSize, }, Platform.OS === 'web' && theme?.addEditProductStyle.webRowHeadingText]}
                  color={theme?.lightDark}
                  bold={true}
                />
                {width > 600 ? <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                  {/* {productId ? <ZenButton
                    title="+ Inventory adjustment history"
                    titleStyle={{ fontSize: theme?.smallHeaderFontSize, color: theme?.grey }}
                    buttonStyle={{ width: width < 600 ? 150 : undefined }}
                    roundedSize={'md'}
                    outlineColor={theme?.primary}
                    type='outline'
                    onPress={() => {
                      navigation.navigate('InventoryAdjustmentHistory');
                    }}
                  /> : undefined} */}
                  {isProductWrite && <ZenButton
                    title="+ Add location"
                    titleStyle={{ fontSize: theme?.smallHeaderFontSize, }}
                    buttonStyle={{ backgroundColor: theme?.primary, width: width < 600 ? 150 : undefined }}
                    roundedSize={'md'}
                    onPress={() => {
                      let empty = false
                      formik?.values?.locArr.map((loc, i: number) => {
                        const isLocEmpty = loc?.selectedLoc === "" || loc?.selectedLoc === undefined || loc?.selectedLoc === null;
                        if (!loc?.isInfinite) {
                          formik?.setFieldTouched(`locArr[${i}].stock`, true)
                          formik?.setFieldTouched(`locArr[${i}].threshold`, true)
                          if (isLocEmpty || loc.stock === "" || loc?.threshold === '') {
                            empty = true
                          }
                        } else {
                          if (isLocEmpty) {
                            empty = true
                          }
                        }
                      })

                      if (!empty) {
                        if (formik?.values?.locArr.length < locationOptions.length) {
                          addLocation()
                        }
                        else {
                          ZenToast({ message: "All the locations are already available", type: "error" })
                        }
                      }
                      else {
                        ZenToast({ message: "Fill the previous location details", type: "error" })
                      }
                    }}
                  />}
                </View> : <Popover
                  isVisible={isPopover}
                  popoverStyle={{ width: 200 }}
                  onRequestClose={() => {
                    setIsPopover(false);
                  }}
                  from={
                    <Pressable
                      onPress={() => {
                        setIsPopover(true);
                      }}>
                      <ZenIcon
                        type="ionicon"
                        name="ellipsis-vertical"
                        color={theme.grey}
                      />
                    </Pressable>
                  }>
                  <View style={{ padding: 5 }}>
                    {/* {productId && (
                      <ZenText
                        style={theme.addEditProductStyle.textStyle}
                        content="+ Inventory adjustment history"
                        onPress={() => {
                          navigation.navigate('InventoryAdjustmentHistory');
                        }}
                      />
                    )} */}
                    {isProductWrite && <ZenText
                      style={theme.addEditProductStyle.textStyle}
                      content="+ Add Location"
                      onPress={() => {
                        let empty = false
                        formik?.values?.locArr.map((loc, i: number) => {
                          const isLocEmpty = loc?.selectedLoc === "" || loc?.selectedLoc === undefined || loc?.selectedLoc === null;
                          if (!loc?.isInfinite) {
                            formik?.setFieldTouched(`locArr[${i}].stock`, true)
                            formik?.setFieldTouched(`locArr[${i}].threshold`, true)
                            if (isLocEmpty || loc.stock === "" || loc?.threshold === '') {
                              empty = true
                            }
                          } else {
                            if (isLocEmpty) {
                              empty = true
                            }
                          }
                        })
                        if (!empty) {
                          if (formik?.values?.locArr.length < locationOptions.length) {
                            addLocation()
                          }
                          else {
                            ZenToast({ message: "All the locations are already available", type: "error" })
                          }
                        }
                        else {
                          ZenToast({ message: "Fill the previous location details", type: "error" })
                        }
                      }}
                    />}
                  </View>
                </Popover>}
              </View>
              {formik?.values?.locArr?.map((item, index: number) => (
                <View key={index} style={[theme.addEditProductStyle.locView, {
                  // zIndex: 0 - (index + 1),
                  marginBottom: ((formik?.values?.locArr?.length - 1) == index) ? 0 : 15
                }]}>
                  <View style={{ marginBottom: 5 }} >
                    <View style={{ flex: 1 }}>
                      <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', marginRight: 2, marginBottom: 5 }}>
                        <ZenText content="Location *" size={theme?.smallHeaderFontSize} bold color={theme?.labelColor} style={Platform.OS === 'web' && theme?.addEditProductStyle.webFieldLabel} />
                        {isProductWrite && formik?.values?.locArr.length > 1 && <ZenIcon type='material-community' name='delete-outline' size={25} color={theme?.darkRed} onPress={() => {
                          if (formik?.values?.locArr.length > 1) {
                            removeLocation(index)
                          }
                          else {
                            ZenToast({ message: "Atleast have one location value", type: "error" })
                          }
                        }} />}
                      </View>

                      <ZenDropdown
                        setOpen={() => { }}
                        disabled={!isProductWrite}
                        setValue={() => { }}
                        items={locationOptions as ItemTypeValue[]}
                        searchable={true}
                        value={item?.selectedLoc}
                        autoScroll={true}
                        scrollViewProps={{ showsVerticalScrollIndicator: false, nestedScrollEnabled: true }}
                        onSelectItem={(selected) => {
                          let duplicate = false
                          if (item.selectedLoc != selected.value) {
                            formik?.values?.locArr.map((selLoc) => {
                              if (selLoc.selectedLoc == selected.value) {
                                duplicate = true
                              }
                            })
                            if (!duplicate) {
                              formik.setFieldValue(`locArr[${index}].selectedLoc`, selected.value)
                              setLocationOpen(prev => {
                                let arr = [...prev]
                                arr[index] = false
                                return arr
                              })
                            }
                            else {
                              setLocationOpen(prev => {
                                let arr = [...prev]
                                arr[index] = false
                                return arr
                              })
                              ZenToast({ message: "Location already exists!", type: "error" })
                            }
                          }
                          else {
                            setLocationOpen(prev => {
                              let arr = [...prev]
                              arr[index] = false
                              return arr
                            })
                          }
                        }}
                        placeholder={(!item?.selectedLoc || item?.selectedLoc === "") ? 'Select location' : locationOptions?.find(data => data.value == item.selectedLoc)?.label}
                        placeholderStyle={{ color: theme.lightDark }}
                        dropDownContainerStyle={item?.isInfinite ? theme?.addEditProductStyle.dropDownContainer : {}}
                        maxHeight={150}
                        open={locationOpen[index]}
                        onPress={() => {
                          setLocationOpen(prev => {
                            let arr = [...prev]
                            arr[index] = !arr[index]
                            return arr
                          })
                        }}
                        style={theme?.addEditProductStyle.input}
                        listItemLabelStyle={{
                          fontSize: theme?.smallerFontSize,
                        }}
                        labelStyle={theme?.addEditProductStyle.mediumLabelStyle}
                      />
                      {!locationOpen[index] && (formik?.errors?.locArr?.[index] as formikLocation)?.selectedLoc ? (
                        <ZenText content={(formik?.errors?.locArr?.[index] as formikLocation)?.selectedLoc} color={theme.red} size={theme?.errorFontSize} />
                      ) : null}
                    </View>
                    <View style={theme?.addEditProductStyle.stockContainer}>
                      <ZenInput
                        keyboardType="numeric"
                        disabled={!isProductWrite}
                        returnKeyType='done'
                        type='outlined'
                        label="Stock *"
                        value={item.stock}
                        onChangeText={(text: string) => {
                          formik.setFieldValue(`locArr[${index}].stock`, text)
                        }}
                        onBlur={() => { formik?.setFieldTouched(`locArr[${index}].stock`, true); formik.handleBlur(`locArr[${index}].stock`) }}
                        inputStyle={theme?.addEditProductStyle.input}
                        errorMessage={formik?.touched?.locArr && formik?.touched?.locArr?.[index]?.stock && (formik?.errors?.locArr?.[index] as formikLocation)?.stock ? (formik?.errors?.locArr?.[index] as formikLocation)?.stock : undefined}
                        errorStyle={[theme.addEditProductStyle.errorStyle, { paddingBottom: formik?.touched?.locArr && formik?.touched?.locArr?.[index]?.stock && (formik?.errors?.locArr?.[index] as formikLocation)?.stock ? 20 : 0 }]}
                      />
                    </View>
                    {/* Low stock threshold value */}
                    <ZenInput
                      keyboardType="numeric"
                      disabled={!isProductWrite}
                      type='outlined'
                      returnKeyType='done'
                      label="Low stock threshold value *"
                      value={item?.threshold}
                      inputStyle={theme?.addEditProductStyle.input}
                      onChangeText={(text: string) => {
                        formik.setFieldValue(`locArr[${index}].threshold`, text)
                      }}
                      onBlur={() => { formik?.setFieldTouched(`locArr[${index}].threshold`, true); formik.handleBlur(`locArr[${index}].threshold`) }}
                      errorMessage={formik?.touched?.locArr && formik?.touched?.locArr?.[index]?.threshold && (formik?.errors?.locArr?.[index] as formikLocation)?.threshold ? (formik?.errors?.locArr?.[index] as formikLocation)?.threshold : undefined}
                      errorStyle={[theme.addEditProductStyle.errorStyle, { paddingBottom: formik?.touched?.locArr && formik?.touched?.locArr?.[index]?.threshold && (formik?.errors?.locArr?.[index] as formikLocation)?.threshold ? 20 : 0 }]}
                    />

                  </View>

                </View>
              ))}
            </View>}
            <CommonImageUpload
              bottomRef={bottomRef}
              propFn={handleImage}
              gallery={{ isStoreGallery: true, sectionName: "products", screenName: "products", }}
              selectedIndex={{ value: { imagesMaxLength: zenType === "multi" ? (formik.values.additionalImages?.length ? (5 - formik.values.additionalImages.length) : 5) : 1 } }}
            />
          </ScrollView>
          {/* Disable Variants */}
          <Popover
            isVisible={isClearVar}
            popoverStyle={[
              theme?.addEditProductStyle.popoverStyle, {
                width: width > 900 ? 600 : width > 600 ? 500 : 300,
              }
            ]}>
            <CommonDialogBox
              type='OTHER'
              dialog={clearVarProps}
              confirmation={confirmation}
            />
          </Popover>
          {/* Enable Variants */}
          <Popover
            isVisible={isEnabVar}
            popoverStyle={[
              theme?.addEditProductStyle.popoverStyle, {
                width: width > 900 ? 600 : width > 600 ? 500 : 300,
              }
            ]}>
            <CommonDialogBox
              type='OTHER'
              dialog={enabVarProps}
              confirmation={confirmation}
            />
          </Popover>
        </KeyboardAvoidingView>
      )}
    </ThemeConsumer>
  )
}

export default ProductGeneral